import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {
  AiChatSendRequest,
  AiChatMessageResponse,
  AiChatMessage,
} from '../models/skill-learning.model';
import { SKILL_CHAT_API } from '../constants/skill-api.constants';

@Injectable()
export class SkillChatApiService {

  private readonly jsonHeaders = new Headers({ 'Content-Type': 'application/json' });
  private readonly jsonOptions = new RequestOptions({ headers: this.jsonHeaders });

  constructor(private http: Http) {}

  sendMessage(specializationId: string, request: AiChatSendRequest): Observable<AiChatMessageResponse> {
    return this.http
      .post(SKILL_CHAT_API.MESSAGE(specializationId), JSON.stringify(request), this.jsonOptions)
      .map(response => response.json() as AiChatMessageResponse);
  }

  fetchChatHistory(specializationId: string): Observable<AiChatMessage[]> {
    return this.http
      .get(SKILL_CHAT_API.HISTORY(specializationId))
      .map(response => response.json() as AiChatMessage[]);
  }

  clearChat(specializationId: string): Observable<void> {
    return this.http
      .delete(SKILL_CHAT_API.CHAT(specializationId))
      .map(() => null);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-chat-api.service.ts